import { FC } from 'react';
import { StyledSection } from './SurveyWrapperInner.styles';
import { Text, Types } from '@marriott/mi-ui-library';
import { SurveyWrapperInnerProps } from './SurveyWrapperInner.types';

export const SurveyWrapperInner: FC<SurveyWrapperInnerProps> = (props: SurveyWrapperInnerProps) => {
  return (
    <>
      {props?.beforeSuveryWrapperInner && (
        <Text
          element={Types.tags.div}
          fontSize={Types.size.medium}
          dangerouslySetInnerHTML={{
            __html: props?.beforeSuveryWrapperInner,
          }}
          customClass="box-section-model"
        ></Text>
      )}
      <StyledSection>{props.children}</StyledSection>
      {props?.afterSuveryWrapperInner && (
        <Text
          element={Types.tags.div}
          fontSize={Types.size.medium}
          dangerouslySetInnerHTML={{
            __html: props?.afterSuveryWrapperInner,
          }}
          customClass="box-section-model"
        ></Text>
      )}
    </>
  );
};
